import { makeObservable, observable } from 'mobx';
import { httpPost } from 'src/axios/axiosUtils';
import { reportSignature } from 'src/axios/requests';
import { LoadingState } from 'src/axios/types';
import { Stores } from 'src/stores';
import { BaseBackendStore } from '../types';
import { PostSignatureDto } from './types';

export class ReportStore extends BaseBackendStore {
  @observable createSignatureState: LoadingState = LoadingState.IDLE;

  constructor(public rootStore: Stores) {
    super();
    makeObservable(this);
  }

  async createSignature(reportId: number, signature: PostSignatureDto) {
    try {
      this.createSignatureState = LoadingState.LOADING;
      const response = await httpPost(reportSignature(reportId), signature);
      this.createSignatureState = LoadingState.DONE;
      return response;
    } catch (error) {
      this.createSignatureState = LoadingState.FAILED;
    }
  }
}
